module.exports = __webpack_public_path__ + "static/media/18.67ed2488.jpg";